import { Box, Button, OutlinedInput } from '@mui/material';
import { useNavigate } from 'react-router';
import SearchIcon from '@mui/icons-material/Search';
import SearchLoader from '../SearchLoader';

const Toolbar = ({ route, filterItem, searchLoader, text, ...props }) => {
  const navigate = useNavigate();
  return (
    <Box {...props}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            width: '17%'
          }}
        >
          <OutlinedInput
            size="small"
            id="search"
            fullWidth
            type="text"
            placeholder="Search"
            startAdornment={
              <SearchIcon sx={{ height: '20px', color: '#a5aebb' }} />
            }
            endAdornment={searchLoader && <SearchLoader />}
            onChange={(e) => {
              filterItem(e.target.value);
            }}
          />
        </Box>
        <Button
          sx={{
            textTransform: 'none',
            transition: '.5s',
            height: '80%',
            opacity: '.9',
            '&:hover': {
              opacity: '1',
              transform: 'scale(.9)'
            }
          }}
          color="primary"
          variant="contained"
          onClick={() => navigate(route)}
        >
          {text}
        </Button>
      </Box>
    </Box>
  );
};

export default Toolbar;
